export interface MemberEntry {
  id?: string;
  userId: string;
  userName: string;
  number: number;
}

export interface IntScorozvonForm {
  groupName: string;
  managerId: string;
  managerName: string;
  members: MemberEntry[];
}

export const EMPTY_INT_SCOROZVON_FORM: IntScorozvonForm = {
  groupName: '',
  managerId: '',
  managerName: '',
  members: [],
};
